import { IClauseChecklistStats } from "@/api";
import { Paper } from "@mui/material";
import { PieChart } from "@mui/x-charts";
import { ClauseChecklistsLegend } from "./ClauseChecklistsLegend";
const CHART_COLORS = ["#74AFED", "#B4CDE8", "#EBF3FB"];

interface IProps {
    clauseChecklists: IClauseChecklistStats[];
}

export const ClauseChecklists = ({ clauseChecklists }: IProps) => {
    // sort by highest count desc
    clauseChecklists.sort((a, b) => b.count - a.count);

    // get top 3 clause checklists
    const topThreeClauseChecklists = clauseChecklists.slice(0, 3);
    const data = topThreeClauseChecklists
        .map((type, index) => ({
            id: type.id,
            value: type.count,
            label: type.name,
            color: CHART_COLORS[index],
        }))
        .filter((o) => o.value > 0);

    return (
        <Paper
            variant="outlined"
            sx={{
                width: "100%",
                height: 294,
                p: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
            }}
        >
            <PieChart
                skipAnimation
                series={[
                    {
                        data,
                        innerRadius: "60%",
                    },
                ]}
                slots={{
                    legend: () =>
                        data.length > 0 && (
                            <ClauseChecklistsLegend data={data} />
                        ),
                }}
                height={200}
                slotProps={{
                    legend: {
                        direction: "vertical",
                        position: {
                            vertical: "middle",
                            horizontal: "center",
                        },
                    },
                }}
            />
        </Paper>
    );
};
